var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ImportWizardTable',{attrs:{"content-headers":_vm.headers,"content-rows":_vm.rows}})
}
var staticRenderFns = []

export { render, staticRenderFns }